<template>
    <div class="js-author-detail">
        <div class="content-header">
            <ol class="breadcrumb">
                <li>
                    <router-link :to="{ name: 'roleList' }">角色管理</router-link>
                </li>
                <li class="active">(权限绑定)</li>
            </ol>
        </div>
        <div class="content-from">
            <el-form ref="formName">
                <el-form-item label="角色名称" prop="name">
                    <el-input disabled v-model="role.name"></el-input>
                </el-form-item>
                <el-form-item label="角色级别" prop="level">
                    <el-input disabled type="number" v-model="role.level"></el-input>
                </el-form-item>
                <el-form-item label="角色菜单">
                    <div class="bin-menus">
                        <table class='bin-menus-table' v-for="(firstItem, firstIndex) in menus" :key="firstIndex">
                            <tr >
                                <th colspan="2">
                                    <input type="checkbox" :value="firstItem.id" :checked="firstItem.checked" @click="firstMenuClickFun(firstIndex)">
                                    {{firstItem.name}}
                                </th>
                            </tr>
                            <tr v-for="(secondItem, secondIndex) in firstItem.children" :key="secondIndex">
                                <td class="munus-1">
                                    <input type="checkbox" :value="secondItem.id" :checked="secondItem.checked" @click="secondMenuClickFun(firstIndex, secondIndex)">
                                    {{secondItem.name}}
                                </td>
                                <td class="munus-2">
                                    <div v-for="(thirdItem, thirdIndex) in secondItem.children" :key="thirdIndex">
                                        <input type="checkbox" :value="thirdItem.id" :checked="thirdItem.checked" @click="thirdMenuClickFun(firstIndex, secondIndex, thirdIndex)">
                                        {{thirdItem.name}}
                                    </div>
                                </td>
                            </tr>
                        </table>
                    </div>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="saveRoleMenu">保存</el-button>
                    <el-button @click="$router.back(-1)">取消</el-button>
                </el-form-item>
            </el-form>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            roleId: '',
            role: {},
            menus: [],
            saveMenuModel:{},
        }
    },
    created() {
        var _this = this;
        _this.roleId = _this.$route.query.roleId;
        if (_this.roleId) {
            _this.saveMenuModel.roleId = _this.roleId
            _this.detailRole();
            _this.findMenuTree();
        }
    },
    methods: {
        detailRole() {
            var _this = this;
            _this.$common.my_ajax({
                url: 'role/detailRole',
                data: {
                    roleId: _this.roleId
                },
                success: function(response) {
                    if(response.item){
                      _this.role = response.item || {};
                    }
                }
            });
        },
        findMenuTree() {
            var _this = this;
            _this.$common.my_ajax({
                url: 'menu/findTreeMenu',
                data: {
                    roleId: _this.roleId
                },
                success: function(response) {
                    _this.menus = response.items || [];
                }
            });
        },
        thirdMenuClickFun(_firstIndex, _secondIndex, _thirdIndex) {
            var _this = this;
            var menus = _this.menus;
            var thirdItem = menus[_firstIndex].children[_secondIndex].children[_thirdIndex];
            thirdItem.checked = !thirdItem.checked;
            if (thirdItem.checked) {
                menus[_firstIndex].children[_secondIndex].checked = true;
                menus[_firstIndex].checked = true;
            }
            _this.menus = menus;
        },
        secondMenuClickFun(_firstIndex, _secondIndex) {
            var _this = this;
            var menus = _this.menus;
            var secondItem = menus[_firstIndex].children[_secondIndex];
            secondItem.checked = !secondItem.checked;
            for (var i in secondItem.children) {
                secondItem.children[i].checked = secondItem.checked;
            }
            if (secondItem.checked) {
                menus[_firstIndex].checked = true;
            }
            _this.menus = menus;
        },
        firstMenuClickFun(_firstIndex) {
            var _this = this;
            var menus = _this.menus;
            var firstItem = menus[_firstIndex];
            firstItem.checked = !firstItem.checked;
            for (var i in firstItem.children) {
                var secondItem = firstItem.children[i];
                secondItem.checked = firstItem.checked;
                for (var j in secondItem.children) {
                    secondItem.children[j].checked = firstItem.checked;
                }
            }
            _this.menus = menus;
        },
        saveRoleMenu() {
            var _this = this;
            var menuIds = [];
            var menus = _this.menus;
            for (var i in menus) {
                var firstItem = menus[i];
                if (firstItem.checked) {
                    menuIds.push(firstItem.id);
                }
                for (var j in firstItem.children) {
                    var secondItem = firstItem.children[j];
                    if (secondItem.checked) {
                        menuIds.push(secondItem.id);
                    }
                    for (var k in secondItem.children) {
                        var thirdItem = secondItem.children[k];
                        if (thirdItem.checked) {
                            menuIds.push(thirdItem.id);
                        }
                    }
                }
            }
            _this.$common.my_ajax({
                url: '/roleMenu/saveRoleMenu',
                contentType: 'application/json',
                data: {
                    roleId: _this.roleId,
                    menuIds: menuIds
                },
                success: function(response) {
                    _this.findMenuTree();
                    _this.$message({
                        type: 'success',
                        message: '绑定成功'
                    });
                }
            });
        }
    },
}
</script>
<style scoped>
.bin-menus{
    margin-top: 20px;
    padding-left: 15% ;
}
.bin-menus-table{
    border: 1px solid black;
    width: 100%;
}

.bin-menus-table th{
    width: 30%;
}
.bin-menus-table td{
    border: 1px solid black;
}
 .bin-menus-table .munus-1{
    width: 25%;
}
.bin-menus-table .munus-2{
    width: 75%;
}
.bin-menus-table .munus-2 div{
    width: 25%;
    float: left;
    padding: 10px;
}
.bin-menus-bnt{
    margin:20px;
}
</style>